import _ from "lodash";

const API_BASE_URL = process.env.API_BASE_URL;

class ApiError extends Error {
  constructor(message, code) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
    Error.captureStackTrace(this, this.constructor);
  }
}

export const sendRequest = async (
  path,
  method = "GET",
  body = {},
  headers = {},
) => {
  const url = new URL(`${API_BASE_URL}${path}`);

  const opts = {
    method: method,
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      ...headers,
    },
    credentials: "include", // cookies
  };

  if (Object.keys(body).length > 0) {
    if (method === "GET") {
      url.search = new URLSearchParams(body).toString();
    } else {
      opts.body = JSON.stringify(body);
    }
  }

  try {
    const response = await fetch(url, opts);
    if (!response.ok) {
      const json = await response.json();

      if (
        response.status === 401 &&
        !window.location.pathname.startsWith("/onboarding")
      ) {
        window.location = "/onboarding";
      }
      const errors = _.join(
        _.get(json, "errors.full_messages") || json.errors,
        ", ",
      );
      const message = json.message || json.error || errors;
      if (response.status === 500) {
        throw new ApiError("Internal Server Error", response.status);
      } 

      throw new ApiError(message, response.status);
    }

    if (response.status !== 204) {
      return await response.json();
    }
  } catch (error) {
    throw new ApiError(error.message || "Internal Server Error", error.code || 500);
  }
};
